import axios from "axios";

const backendUrl = process.env.REACT_APP_BACKEND_URL;
const cleanedBackendUrl = backendUrl.replace("/backend", "");

const InventoryService = {
  fetchDataInventory(itemName, partnerId, itemState, tagMain, tagSecondary, brand, stock, page, perPage) {
    return axios.get(
      `${backendUrl}/admin/dataInventori`,
      {
        params: {
          itemName: itemName,
          partnerId: partnerId,
          itemState: itemState,
          tagMainId: tagMain,
          tagSecondaryId: tagSecondary,
          brandId: brand,
          stockStatus: stock,
          page: page,
          perPage: perPage
        }
      }
    );
  },
  fetchDataItemTypesPageable(page, perPage, name) {
    return axios.get(
      `${cleanedBackendUrl}/items/types/pageable`,
      {
        params: {
          page: page,
          perPage: perPage,
          name: name
        }
      }
    );
  },
  updateStockVariant(itemId, stockVariant) {
    const formData = new FormData();
    formData.append('stockVariant', stockVariant);

    return axios.patch(
      `${backendUrl}/admin/updateStockVariant/${itemId}`,
      formData
    )
  }
};

export default InventoryService;